import { useQuery } from "@tanstack/react-query";
import { getSettingsRequest } from "../requests/setting";

export function useSettings({ params } = {}) {
  return useQuery({
    queryKey: [`/v1/settings`],
    queryFn: async () => {
      const res = await getSettingsRequest({
        params: params,
      });
      return res.data?.data;
    },
  });
}
